import { Component } from '@angular/core';

@Component({
  selector: 'app-main-transactions',
  templateUrl: './main-transactions.component.html',
  styleUrls: ['./main-transactions.component.css']
})
export class MainTransactionsComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }
}
